<template>
    <div class="url-container">
      <div class="left-container">
        <div class="url-title">输入url</div>
        <div class="url">
          <el-input v-model="data.urlValue" @input="updateHint" @keyup.enter.native="preview"/>
        </div>
        <div class="url-preview">
          <el-button @click="preview">预览</el-button>
        </div>
        <div class="operation">
          <el-button type="primary" @click="saveData">保存</el-button>
          <el-button @click="closeDialog">取消</el-button>
        </div>
      </div>
      <div class="right-container">
        <iframe v-show="iframeUrl !== ''" class="iframe" :src="iframeUrl" frameborder="0"></iframe>
        <div v-if="iframeUrl === ''" class="none-url">{{hint}}</div>
      </div>
    </div>
</template>

<script>
export default {
  props: ['data'],
  name: 'url-page',
  data () {
    return {
      iframeUrl: '',
      hint: '嵌入网页、视频、图片链接, 你也可以嵌入一个视图、记录的分享链接'
    }
  },
  methods: {
    preview () {
      this.verifyUrl().then(() => {
        this.iframeUrl = ''
        let reg = /(www\.){0,1}.+\.(com|net|cn|cc|top|org|gov|edu)+/
        if (reg.test(this.data.urlValue)) {
          this.iframeUrl = this.disposeUrl(this.data.urlValue)
        } else {
          this.hint = '嵌入连接无法解析'
        }
      })
    },
    verifyUrl () {
      return new Promise(resolve => {
        if (this.data.urlValue.trim() !== '') {
          resolve()
        } else {
          return this.$message.info('请输入url')
        }
      })
    },
    disposeUrl (url) {
      let reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g
      return reg.test(url) ? url : `https://${url}`
    },
    updateHint () {
      this.hint = '嵌入网页、视频、图片链接, 你也可以嵌入一个视图、记录的分享链接'
    },
    closeDialog () {
      this.$emit('closeDialog')
    },
    saveData () {
      this.verifyUrl().then(() => {
        let reg = /(www\.){0,1}.+\.(com|net|cn|cc|top|org|gov|edu)+/
        if (reg.test(this.data.urlValue)) {
          this.$emit('addControls', this.data, true)
        } else {
          this.$message.error('请输入正确格式url！')
        }
      })
    }
  },
  created () {
    if (this.data.urlValue.trim() !== '') {
      this.iframeUrl = this.disposeUrl(this.data.urlValue)
    }
  }
}
</script>

<style lang="scss">
  .url-container {
    width: 100%;
    height: 100%;
    display: flex;
    .left-container {
      width: 230px;
      border-right: 1px solid #DCDCDC;
      padding: 16px 11px;
      height: 100%;
      .url-title {
        color: #1A1A1A;
        font-size: 14px;
        padding-bottom: 14px;
      }
      .url-preview, .operation {
        .el-button {
          width: 58px;
          padding: 0;
          border-radius: 4px;
          height: 26px;
          line-height: 25px;
        }
      }
      .url-preview {
        padding: 13px 0 38px 0;
        text-align: right;
      }
      .operation {
        text-align: center;
        .el-button {
          width: 78px;
        }
        .el-button--primary {
          margin-right: 13px;
        }
      }
    }
    .right-container {
      width: calc(100% - 230px);
      height: 100%;
      .iframe {
        width: 100%;
        height: 100%;
      }
      .none-url {
        color: #999999;
        padding-top: 255px;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/customPage/url-page.vue